import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import { Input } from 'reactstrap';

export default function SearchBox({ onChange, timeout, ...inputProps }) {
  const [timer, setTimer] = useState();
  const [value, setValue] = useState();
  const inputEl = useRef(null);

  const reset = () => {
    clearTimeout(timer);
    setTimer(null);
    const currentValue = inputEl.current.value;
    if (onChange && value !== currentValue) {
      setValue(inputEl.current.value);
      onChange({ target: { value: currentValue, timer } });
    }
  };

  return (
    <Input
      placeholder="Search ..."
      innerRef={inputEl}
      {...inputProps}
      type="search"
      onKeyDown={(e) => {
        if (e.keyCode === 13) reset();
      }}
      onBlur={() => reset()}
      onChange={() => {
        clearTimeout(timer);
        setTimer(setTimeout(reset, timeout));
      }}
    />
  );
}

SearchBox.defaultProps = {
  timeout: 1500,
};

SearchBox.propTypes = {
  onChange: PropTypes.func,
  timeout: PropTypes.number,
};
